import React, { useState, useEffect, useRef } from "react";
import { Menu } from "primereact/menu";
import { useSelector, useDispatch } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { FilterMatchMode } from "primereact/api";
import { useApi } from "../../utils/requests";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/local";
import { toastError, toastSuccess } from "../../store/toastSlice";
import { InputNumber } from "primereact/inputnumber";
import { getVendorStatusFromBuyerStatus } from "../../utils/statusMapper";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { getRates } from "../../utils/exchangeRates";
import { set } from "react-hook-form";
import VendorBiddingPanel from "./VendorBiddingPanel";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { v4 as uuidv4 } from "uuid";
import { setAuctions } from "../../store/auctionSlice";
import { BASE_URL, API_URL } from "../../constants";
import VendorCostUpload from "./VendorCostUpload";

const RfqManagement = () => {
  const op = useRef(null);
  const { postData, getData } = useApi();
  const user = useSelector((state) => state.auth.user);
  //console.log("user info on lisitng", user);
  const role = user?.role;
  //console.log("User Role:", role);
  const isVendor = user?.role === "vendor";
  //console.log("isVendor value", isVendor);
  const [rfqs, setRfqs] = useState([]);
  const [currencyExchangeRates, setCurrencyExchangeRates] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  // const [filters, setFilters] = useState({
  //   global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //   title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //   type: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //   transport_mode: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //   currency: { value: null, matchMode: FilterMatchMode.CONTAINS },
  // });

  const [filters, setFilters] = useState({
    rfq_number: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "buyer.preshipmentnumber": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    title: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    form_type: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    status: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    vendorsResponded: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    createdAt: {
      value: null,
      matchMode: FilterMatchMode.DATE_IS,
    },
    open_date_time: {
      value: null,
      matchMode: FilterMatchMode.DATE_IS,
    },
    close_date_time: {
      value: null,
      matchMode: FilterMatchMode.DATE_IS,
    },
  });

  const [expandedRows, setExpandedRows] = useState(null);
  const [quotes, setQuotes] = useState({});
  const [roadTransportQuotes, setRoadTransportQuotes] = useState({});
  const [negotiationData, setNetogiationData] = useState({});
  const [quoteAcceptedData, setQuoteAcceptedData] = useState({});
  const [hodAcceptRequestData, setHodAcceptRequestData] = useState({});
  const [competingQuotes, setCompetingQuotes] = useState({});
  const userRole = "vendor";
  const airlines = ["Air India", "Emirates", "Qatar Airways"];
  const [packageQuotes, setPackageQuotes] = useState({});

  const [airlineQuotes, setAirlineQuotes] = useState({});

  const [airlineData, setAirlineData] = useState({});
  const [shiplineData, setShiplineData] = useState({});
  const [roadTransportData, setRoadTransportData] = useState({});

  const [expandedModalRows, setExpandedModalRows] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("INR");

  const [exchangeRate, setExchangeRate] = useState(1);
  const [totaldapdppcharge, setTotaldapdppCharge] = useState(0);
  const [fetchingRateMsg, setFetchingRateMsg] = useState(null);

  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [invoiceFiles, setInvoiceFiles] = useState({});

  const [showVendorAuctionDialog, setShowVendorAuctionDialog] = useState(false);
  const [userId, setUserId] = useState(uuidv4().slice(0, 8));
  const [auctionData, setAuctionData] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rfqNumberForQuoteSummary, setRfqNumberForQuoteSummary] =
    useState(null);
  const [showVendorUpload, setShowVendorUpload] = useState(false);
  const [quoteRankingBeforeAuction, setQuoteRankingBeforeAuction] =
    useState(null);

  const toggleMoreInfo = (shipmentIndex, rowIndex) => {
    setExpandedModalRows((prev) => ({
      ...prev,
      [`${shipmentIndex}_${rowIndex}`]: !prev[`${shipmentIndex}_${rowIndex}`],
    }));
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (!role == undefined) {
      navigate("/login");
    }
  }, [user, navigate]);

  const fetchRfqs = async () => {
    try {
      const url = isVendor
        ? `rfqs?email=${encodeURIComponent(user.email)}`
        : `rfqs`;
      //console.log("Fetching RFQs from URL:", url);
      const data = await getData(url);

      // RFQs that contain auction_data with an id
      const rfqsWithAuction = data.filter(
        (rfq) => rfq.auction_data && rfq.auction_data.id,
      );

      // Extract only auction_data (normalized)
      const auctions = rfqsWithAuction.map((rfq) => ({
        ...rfq.auction_data,
        rfq_number: rfq.rfq_number,
        title: rfq.title,
      }));

      dispatch(setAuctions(auctions));
      console.log("Fetched Auctions:", auctions);

      //console.log("Fetched RFQs:", data);
      const enriched = data.map((r) => ({
        ...r,
        row_id: r.auction_number || r.rfq_number,
      }));
      let result = enriched;

      // if (role === "hod") {
      //   result = enriched.filter(
      //     (rfq) =>
      //       rfq.status === "requested_hod_approval" ||
      //       rfq.status === "hod_approved" ||
      //       rfq.status === "hod_rejected" ||
      //       rfq.status === "documents_submitted_by_exports",
      //   );
      //   setRfqs(result);
      // } else {
      setRfqs(enriched);
      //}
    } catch (error) {
      console.error("Error fetching RFQs:", error);
    }
  };

   const fetchCurrencyExchangeRates = async () => {
    try {
      const data = await getData("currency-exchange-rates");

      const currentDate = new Date();

      const validRates = data.filter((item) => {
        const validFrom = new Date(item.valid_from);
        const validTo = new Date(item.valid_to);

        return currentDate >= validFrom && currentDate <= validTo;
      });

      setCurrencyExchangeRates(validRates);

      console.log("All Currency Exchange Rates:", data);
      console.log("Currently Valid Currency Exchange Rates:", validRates);
    } catch (error) {
      console.error("Error fetching currency exchange rates:", error);
    }
  };

  const fetchAuctionDataById = async (rfqNumber) => {
    try {
      const response = await getData(`rfqs/${rfqNumber}`, {});
      setAuctionData(response?.rfqRecord?.data?.auction_data || null);
    } catch (error) {}
  };

  const fetchQuoteSummary = async (rfqNumber) => {
    setRfqNumberForQuoteSummary(rfqNumber);
    try {
      const response = await getData(
        `quotesummary/quotes-summary/${rfqNumber}`,
      );

      const rfqNo = response?.rfq_number;

      const formattedData =
        response?.shipments?.flatMap((shipment, shipmentIndex) =>
          shipment?.quotes
            //?.filter((quote) => quote.vendor_id === user.id) // 🔥 FILTER HERE
            ?.map((quote) => ({
              rfq_number: rfqNo,
              shipment_index: shipmentIndex,
              vendor_id: quote.vendor_id,
              vendor_name: quote.vendor_name,
              airline: quote.airline_name,
              airport: quote.airport,
              rank: quote.rank,
              email: quote.vendor_email,
            })),
        ) || [];

      setQuoteRankingBeforeAuction(formattedData);
    } catch (error) {
      console.error("Error fetching quote summary:", error);
    }
  };

  const getRankForRow = (shipmentIndex, airlineName) => {
    return (
      quoteRankingBeforeAuction?.find(
        (r) =>
          r.vendor_id === user.id &&
          r.shipment_index === shipmentIndex &&
          r.airline === airlineName,
      )?.rank || null
    );
  };

  useEffect(() => {
    // this runs IMMEDIATELY after state updates & re-render
    console.log("Ranks updated:", quoteRankingBeforeAuction);
  }, [quoteRankingBeforeAuction]);

  const handleRowExpand = (e) => {
    const key = e.data.row_id;
    setExpandedRows({ [key]: true });
    fetchQuotesById(e.data.rfq_number);
    fetchAuctionDataById(e.data.rfq_number);
    fetchQuoteSummary(e.data.rfq_number);
  };

  const handleRowCollapse = (e) => {
    setExpandedRows({});
  };

  const fetchQuotesById = async (rfqNumber) => {
    setQuotes({});
    setCompetingQuotes({});
    setAirlineQuotes({});
    setAirlineData({});
    setShiplineData({});
    setRoadTransportQuotes({});
    setNetogiationData([]);
    setQuoteAcceptedData({});
    setHodAcceptRequestData({});
    try {
      const data = await getData(`quotes/${rfqNumber}`);
      const mappedQuotes = {};
      const mappedRoadTransportQuotes = {};
      const groupedByItem = {};
      const mappedPackageQuotes = {};
      const mappedExportAirlinePackageQuotes = {};
      const mappedExportShiplinePackageQuotes = {};

      data.forEach((entry) => {
        const rfqId = entry.rfq_id;

        if (String(entry.vendor_id) === String(user.id)) {
          entry.quotes?.forEach((q) => {
            const key = `${rfqId}_${q.item_id}`;
            mappedQuotes[key] = q.quoted_price;
          });

          entry.road_transport_quotes?.forEach((q) => {
            const key = `${rfqId}_${q.row_id}`;
            mappedRoadTransportQuotes[key] = q.quoted_price;
          });

          if (entry.package_quotes) {
            entry.package_quotes?.forEach((pkg) => {
              const rowIndex = pkg.row_index;
              pkg.quotes.forEach((q) => {
                const airlineKey = `${rfqId}_${rowIndex}_${q.airline}`;
                mappedPackageQuotes[airlineKey] = {
                  base: q.base || "",
                  air_freight: q.air_freight || "",
                  customs: q.customs || "",
                };
              });
              //console.log("package value", pkg);
              const shipmentIndex = pkg?.shipment_index;
              //console.log("shipmentIndex value", shipmentIndex);
              if (!mappedExportAirlinePackageQuotes[shipmentIndex]) {
                mappedExportAirlinePackageQuotes[shipmentIndex] = [];
              }

              pkg.quotes?.forEach((quote) => {
                const isSealine = "sealine_name" in quote;

                //console.log("isSealine value", isSealine);

                const targetMap = isSealine
                  ? mappedExportShiplinePackageQuotes
                  : mappedExportAirlinePackageQuotes;

                if (!targetMap[shipmentIndex]) {
                  targetMap[shipmentIndex] = [];
                }

                if (isSealine) {
                  targetMap[shipmentIndex].push({
                    sealine_name: quote.sealine_name || "",
                    sea_port: quote.sea_port || "",
                    freight_per_container: quote.freight_per_container || "",
                    temperature: quote.temperature || "",
                    dap_ddp: quote.dap_ddp || "",
                    transit_time: quote.transit_time || "",
                    freight_per_cbm: quote.freight_per_cbm || "",
                    origin_charges: quote.origin_charges || "",
                    destination_charges: quote.destination_charges || "",
                    remarks: quote.remarks || "",
                    rate_validity: quote.rate_validity || "",
                    all_in_freight: quote.all_in_freight || "",
                    thc: quote.thc || "",
                    blFee: quote.blFee || "",
                    ensAcdFee: quote.ensAcdFee || "",
                    other_charges: quote.other_charges || "",
                    currency: quote.currency || "",
                    haulage: quote.haulage || "",
                    customs_clearance: quote.customs_clearance || "",
                    isf: quote.isf || "",
                    dthc: quote.dthc || "",
                    doDdc: quote.doDdc || "",
                    hmf: quote.hmf || "",
                    mpe: quote.mpe || "",
                    prePull: quote.prePull || "",
                    other_destination_charges:
                      quote.other_destination_charges || "",
                    origin_detention: quote.origin_detention || "",
                    destination_detention: quote.destination_detention || "",
                    destination_combine: quote.destination_combine || "",
                    shipping_line: quote.shipping_line || "",
                    routing: quote.routing || "",
                    validity: quote.validity || "",
                    total_charges: quote.total_charges || "",
                  });
                } else {
                  targetMap[shipmentIndex].push({
                    airline_name: quote.airline_name || "",
                    airport: quote.airport || "",
                    currency: quote.currency || "",
                    gross_weight: quote.gross_weight || "",
                    volume_weight: quote.volume_weight || "",
                    chargeable_weight: quote.chargeable_weight || "",
                    transit_days: quote.transit_days || "",
                    freight_per_kg: quote.base || "",
                    exchangeRate: quote.exchangeRate || "",
                    dap_ddp_charges: quote.dap_ddp_charges || "",
                    other_charges: quote.other_charges || "",
                    remarks: quote.remarks || "",
                    rate_validity: quote.rate_validity || "",
                    base_rate: quote.base_rate || "",
                    ams: quote.ams || "",
                    pac: quote.pac || "",
                    awb: quote.awb || "",
                    total_charges: quote.total_charges || "",
                    totaldapdppcharge: quote.totaldapdppcharge || "",
                    grandTotalValue: quote.grandTotalValue || "",
                    booking_reference: quote.booking_reference || "",
                    route1: quote?.route1 || "",
                    flight_schedule1: quote?.flight_schedule1 || "",
                    route2: quote?.route2 || "",
                    flight_schedule2: quote?.flight_schedule2 || "",
                    route3: quote?.route3 || "",
                    flight_schedule3: quote?.flight_schedule3 || "",
                    pickup_date: quote.pickup_date || "",
                    clearance_date: quote.clearance_date || "",
                    freight_validity: quote.freight_validity || "",
                    insurance: quote.insurance || "",
                    pickup_charges: quote.pickup_charges || "",
                    documentation_charges: quote.documentation_charges || "",
                    customs_handling: quote.customs_handling || "",
                    free_storage_days: quote.free_storage_days || "",
                    hodAcceptRequestDetails:
                      entry.hodAcceptRequestDetails || {},
                    buyerDocumentsUploadedDetails:
                      entry.buyerDocumentsUploadedDetails || {},
                    invoiceDetails: entry.invoiceDetails || [],
                  });
                }
              });
            });
          }
          if (entry.negotiation) {
            setNetogiationData(entry.negotiation || []);
          }
          if (entry.acceptedDetails) {
            setQuoteAcceptedData(entry.acceptedDetails || {});
          }
          if (entry.hodAcceptRequestDetails) {
            setHodAcceptRequestData(entry.hodAcceptRequestDetails || {});
          }
        }

        entry.quotes?.forEach((q) => {
          const key = `${rfqId}_${q.item_id}`;
          if (!groupedByItem[key]) groupedByItem[key] = [];
          groupedByItem[key].push({
            vendor_id: entry.vendor_id,
            quoted_price: q.quoted_price,
          });
        });
      });
      // console.log(
      //   "mappedExportAirlinePackageQuotes data",
      //   mappedExportAirlinePackageQuotes
      // );
      setQuotes(mappedQuotes);
      setCompetingQuotes(groupedByItem);
      setAirlineQuotes(mappedPackageQuotes);
      setAirlineData(mappedExportAirlinePackageQuotes);
      setShiplineData(mappedExportShiplinePackageQuotes);
      setRoadTransportQuotes(mappedRoadTransportQuotes);
    } catch (error) {
      console.error("Error fetching Qutoes:", error);
    }
  };

  const updateAirlineQuote = (key, field, value) => {
    setAirlineQuotes((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [field]: value,
      },
    }));
  };

  const handleDeliverySubmit = async (rfqNumber) => {
    const delivery = deliveryDetails[rfqNumber];
    const file = invoiceFiles[rfqNumber];

    if (!delivery?.deliveryDate || !file) {
      dispatch(
        toastError({ detail: "Please provide delivery date and invoice." }),
      );
      return;
    }

    const formData = new FormData();
    formData.append("rfq_number", rfqNumber);
    formData.append("vendor_id", user.id);
    formData.append("delivery_date", delivery.deliveryDate.toISOString());
    formData.append("notes", delivery.notes || "");
    formData.append("invoiceAmount", delivery.invoiceAmount || "");
    formData.append("invoice", file);

    try {
      const token = localStorage.getItem("USERTOKEN");
      const response = await fetch("/apis/invoices/submit", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();
      if (result.isSuccess) {
        dispatch(
          toastSuccess({ detail: "Delivery details submitted successfully!" }),
        );
      } else {
        dispatch(toastError({ detail: result.msg || "Submission failed" }));
      }
    } catch (error) {
      console.error("Delivery submission error:", error);
      dispatch(toastError({ detail: "Something went wrong" }));
    }
  };

  const handleAuctionDataRankUpdate = (updatedRanking) => {
    console.log("Received updated ranking from auction data:", updatedRanking);
    if (updatedRanking && Array.isArray(updatedRanking)) {
      setQuoteRankingBeforeAuction(updatedRanking);
    }
  };

  const handlePackageSubmit = async (shipmentIndex, rowData) => {
    const rfqId = rowData.rfq_number;
    const vendorId = user.id;

    const airlineQuotesForShipment = airlineData[shipmentIndex] || [];

    // ❌ If no airline rows added — block submit
    if (airlineQuotesForShipment.length === 0) {
      dispatch(
        toastError({
          detail:
            "Please add at least one airline before submitting the quote.",
        }),
      );
      return; // Stop execution
    }

    // ❌ Validate each airline row (required fields)
    const requiredFields = ["airline_name"];

    for (let i = 0; i < airlineQuotesForShipment.length; i++) {
      const airline = airlineQuotesForShipment[i];

      for (let field of requiredFields) {
        if (!airline[field] || airline[field] === "") {
          dispatch(
            toastError({
              detail: `Please fill Airline Details`,
            }),
          );
          return; // Stop execution
        }
      }
    }

    const payload = {
      rfq_id: rfqId,
      vendor_id: vendorId,
      company: user.company,
      quotes: [],
      package_quotes: [
        {
          shipment_index: shipmentIndex,
          quotes: airlineQuotesForShipment,
        },
      ],
    };

    //console.log("payload data", payload);
    try {
      const result = await postData("quotes", payload);

      console.log("Submit Quote response", result);

      if (!result?.isSuccess) {
        dispatch(
          toastError({
            detail: result?.msg || "Something went wrong",
          }),
        );
      } else {
        dispatch(
          toastSuccess({
            detail: "Auction Quote Submitted Successfully..",
          }),
        );
        await fetchQuoteSummary(rfqId);
      }
    } catch (error) {
      console.error("Error submitting auction quote:", error);

      dispatch(
        toastError({
          detail: "Error submitting auction quote",
        }),
      );
    }
  };

  const handleShiplinePackageSubmit = async (shipmentIndex, rowData) => {
    const rfqId = rowData.rfq_number;
    const vendorId = user.id;

    const shiplineQuotesForShipment = shiplineData[shipmentIndex] || [];

    //console.log("shiplineQuotesForShipment details", shiplineQuotesForShipment);

    const payload = {
      rfq_id: rfqId,
      vendor_id: vendorId,
      quotes: [],
      package_quotes: [
        {
          shipment_index: shipmentIndex,
          quotes: shiplineQuotesForShipment,
        },
      ],
    };
    try {
      const token = localStorage.getItem("USERTOKEN");

      const response = await fetch("/apis/quotes", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      console.log("Submit Quote response:", result);

      // ❌ API returned an error
      if (!response.ok || result?.isSuccess === false) {
        dispatch(
          toastError({
            detail: result?.message || result?.msg || "Failed to submit quote.",
          }),
        );

        return;
      }

      // ✅ API success
      dispatch(
        toastSuccess({
          detail: "Quote Submitted Successfully.",
        }),
      );
    } catch (error) {
      console.error("Error submitting quote:", error);

      dispatch(
        toastError({
          detail: "Failed to submit quote. Please try again.",
        }),
      );
    }
  };

  useEffect(() => {
    fetchRfqs();
    fetchCurrencyExchangeRates();
  }, []);

  const filteredRfqs =
    role === "user" || role === "hod" || role === "accounts" || role === "vendor"
      ? rfqs.filter((rfq) => rfq.form_type?.toLowerCase() !== "draft")
      : rfqs;

  const getVendorRank = (rfqId, itemId, vendorId, competingQuotes) => {
    //console.log("rfqId value", rfqId);
    //console.log("itemId value", itemId);
    //console.log("vendorId value", vendorId);
    //console.log("competingQuotes value", competingQuotes);
    const quotes = competingQuotes[`${rfqId}_${itemId}`] || [];

    //console.log("quotes value", quotes);

    const sorted = [...quotes].sort((a, b) => a.quoted_price - b.quoted_price);
    //console.log("sorted value", sorted);
    const rank = sorted.findIndex(
      (q) => String(q.vendor_id) === String(vendorId),
    );

    //console.log("rank value", rank);

    return rank !== -1 ? `L${rank + 1}` : "-";
  };

  const handleAddAirline = (index) => {
    setAirlineData((prev) => ({
      ...prev,
      [index]: [
        ...(prev[index] || []),
        {
          airline_name: "",
          airport: "",
          gross_weight: "",
          volume_weight: "",
          chargeable_weight: "",
          transit_days: "",
          freight_per_kg: "",
          dap_ddp_charges: "",
          other_charges: "",
          remarks: "",
          rate_validity: "",
          currency: "INR",
        },
      ],
    }));
  };

  const handleAddShipline = (index) => {
    setShiplineData((prev) => ({
      ...prev,
      [index]: [
        ...(prev[index] || []),
        {
          sealine_name: "",
          sea_port: "",
          freight_per_container: "",
          temperature: "",
          dap_ddp: "",
          transit_time: "",
          freight_per_cbm: "",
          origin_charges: "",
          destination_charges: "",
          remarks: "",
          rate_validity: "",
          all_in_freight: "",
          thc: "",
          blFee: "",
          ensAcdFee: "",
          other_charges: "",
          currency: "",
          haulage: "",
          customs_clearance: "",
          isf: "",
          dthc: "",
          doDdc: "",
          hmf: "",
          mpe: "",
          prePull: "",
          other_destination_charges: "",
          origin_detention: "",
          destination_detention: "",
          destination_combine: "",
          shipping_line: "",
          transit_time: "",
          routing: "",
          validity: "",
          remarks: "",
        },
      ],
    }));
  };

  const handleSealineInputChange = (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    value,
  ) => {
    setShiplineData((prev) => {
      const updated = [...(prev[shipmentIndex] || [])];
      const toNumber = (val) => parseFloat(val) || 0;
      updated[rowIndex] = {
        ...updated[rowIndex],
        [field]: value,
      };
      const row = { ...updated[rowIndex], [field]: value };

      const dap_ddp = parseFloat(row.dap_ddp) || 0;
      const origin_charges = parseFloat(row.origin_charges) || 0;
      const destination_charges = parseFloat(row.destination_charges) || 0;
      const thc = parseFloat(row.thc) || 0;
      const blFee = parseFloat(row.blFee) || 0;
      const ensAcdFee = toNumber(row.ensAcdFee);
      const other_charges = toNumber(row.other_charges);
      const haulage = toNumber(row.haulage);
      const customs_clearance = toNumber(row.customs_clearance);
      const isf = toNumber(row.isf);
      const dthc = toNumber(row.dthc);
      const doDdc = toNumber(row.doDdc);
      const hmf = toNumber(row.hmf);
      const mpe = toNumber(row.mpe);
      const prePull = toNumber(row.prePull);
      const other_destination_charges = toNumber(row.other_destination_charges);
      const origin_detention = toNumber(row.origin_detention);
      const destination_detention = toNumber(row.destination_detention);
      const destination_combine = toNumber(row.destination_combine);

      const currency = row.currency || "INR";

      const currencySymbol = currency === "USD" ? "$" : "₹";
      setCurrencySymbol(currencySymbol);

      const exchangeRate = currency === "USD" ? 85.34 : 1;

      row.total_charges = (
        origin_charges +
        destination_charges +
        thc +
        blFee +
        ensAcdFee +
        other_charges +
        haulage +
        customs_clearance +
        isf +
        dthc +
        doDdc +
        hmf +
        mpe +
        prePull +
        other_destination_charges +
        origin_detention +
        destination_detention +
        destination_combine
      ).toFixed(2);

      //console.log("total charge calculation", row.total_charges);

      updated[rowIndex] = row;
      return {
        ...prev,
        [shipmentIndex]: updated,
      };
    });
  };

  const handleDapDdpChange = (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    value,
  ) => {
    const toNumber = (val) => parseFloat(val) || 0;
    const prevData = [...(airlineData[shipmentIndex] || [])];
    const row = { ...prevData[rowIndex], [field]: value };
    let selectedCurrency = row.currency;
    if (!selectedCurrency) selectedCurrency = "INR";
    if (selectedCurrency && exchangeRate) {
      const dapDdp = toNumber(row.dap_ddp_charges);
      const convertedDapDdp = dapDdp * exchangeRate;
      //setTotaldapdppCharge(convertedDapDdp);
      row.totaldapdppcharge = convertedDapDdp;
      const prevTotal = parseFloat(row.total_charges) || 0;
      const prevdapdppTotal = parseFloat(row.totaldapdppcharge) || 0;

      row.grandTotalValue = prevTotal + prevdapdppTotal;
      //row.grandTotalValue = prevTotal;
      prevData[rowIndex] = row;
      setAirlineData((prev) => ({
        ...prev,
        [shipmentIndex]: prevData,
      }));
    }
  };

  const handleExchangeRateChange = (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    newRate,
  ) => {
    setExchangeRate(newRate);

    // Clone the full airline data to work on
    const updatedAirlineData = JSON.parse(JSON.stringify(airlineData));

    // Function to safely convert to number
    const toNumber = (val) => parseFloat(val) || 0;

    // Loop through all shipments and rows to update totals
    Object.keys(updatedAirlineData).forEach((shipIndex) => {
      updatedAirlineData[shipIndex] = updatedAirlineData[shipIndex].map(
        (row, idx) => {
          const dapDdp = toNumber(row.dap_ddp_charges);
          const convertedDapDdp = dapDdp * newRate;
          const prevTotal = toNumber(row.total_charges);
          const grandTotalValue = prevTotal + convertedDapDdp;

          return {
            ...row,
            totaldapdppcharge: convertedDapDdp,
            grandTotalValue,
          };
        },
      );
    });

    // Update the current edited row if needed
    if (
      updatedAirlineData[shipmentIndex] &&
      updatedAirlineData[shipmentIndex][rowIndex]
    ) {
      updatedAirlineData[shipmentIndex][rowIndex][field] = newRate;
    }

    // Finally update the state once
    setAirlineData(updatedAirlineData);
  };

  const handleCurrencyChange = async (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    value,
  ) => {
    const toNumber = (val) => parseFloat(val) || 0;
    const prevData = [...(airlineData[shipmentIndex] || [])];
    const row = { ...prevData[rowIndex], [field]: value };
    let dapDdp = toNumber(row.dap_ddp_charges);

    const currency = row.currency || "INR";

    let exchangeRate = 1;
    try {
      setFetchingRateMsg("Fetching latest exchange rate...");
      exchangeRate = await getRates(currency, "INR");
      row.exchangeRate = exchangeRate;
      setExchangeRate(exchangeRate);
      setFetchingRateMsg(null);
      //console.log("[DEBUG] Fetched exchange rate:", exchangeRate);
    } catch (e) {
      //console.error("Exchange rate error:", e);
    }

    const convertedDapDdp = dapDdp * exchangeRate;
    //console.log("convertedDapDdp value", convertedDapDdp);

    const prevTotal = parseFloat(row.total_charges) || 0;
    row.total_charges = prevTotal;
    row.totaldapdppcharge = convertedDapDdp;
    row.grandTotalValue = row.total_charges + convertedDapDdp;
    //console.log("Total Charges", row.total_charges);

    prevData[rowIndex] = row;
    setAirlineData((prev) => ({
      ...prev,
      [shipmentIndex]: prevData,
    }));
  };

  const handleCurrencyChangeNew = (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    value,
  ) => {
    const toNumber = (val) => parseFloat(val) || 0;

    const prevData = [...(airlineData[shipmentIndex] || [])];

    const row = {
      ...prevData[rowIndex],
      [field]: value,
    };

    let dapDdp = toNumber(row.dap_ddp_charges);

    const currency = row.currency || "INR";

    // Get exchange rate from already fetched currency exchange rate data
    let exchangeRate = 1;

    const currencyRate = currencyExchangeRates.find(
      (item) => item.currency === currency,
    );

    if (currencyRate) {
      exchangeRate = Number(currencyRate.exchange_rate);
    }

    row.exchangeRate = exchangeRate;

    setExchangeRate(exchangeRate);

    const convertedDapDdp = dapDdp * exchangeRate;

    const prevTotal = parseFloat(row.total_charges) || 0;

    row.total_charges = prevTotal;
    row.totaldapdppcharge = convertedDapDdp;
    row.grandTotalValue = row.total_charges + convertedDapDdp;

    prevData[rowIndex] = row;

    setAirlineData((prev) => ({
      ...prev,
      [shipmentIndex]: prevData,
    }));
  };

  const handleInputChange = async (
    shipment,
    shipmentIndex,
    rowIndex,
    field,
    value,
  ) => {
    const toNumber = (val) => parseFloat(val) || 0;
    const prevData = [...(airlineData[shipmentIndex] || [])];
    const row = { ...prevData[rowIndex], [field]: value };

    const gw = toNumber(
      field === "gross_weight"
        ? value
        : shipment.package_summary?.totalGrossWeight,
    );
    const vw = toNumber(
      field === "volume_weight"
        ? value
        : shipment.package_summary?.totalVolumetricWeight,
    );
    //row.chargeable_weight = Math.max(gw, vw);

    const cw = toNumber(row.chargeable_weight);
    const baseRate = toNumber(row.base_rate);
    const freight = toNumber(row.freight_per_kg);
    const other = toNumber(row.other_charges);
    const ams = toNumber(row.ams);
    const pac = toNumber(row.pac);
    const awb = toNumber(row.awb);

    row.total_charges = (cw * baseRate + ams + pac + awb + other).toFixed(2);

    const prevTotal = parseFloat(row.total_charges) || 0;
    const prevdapdppTotal = parseFloat(row.totaldapdppcharge) || 0;

    row.grandTotalValue = prevTotal + prevdapdppTotal;
    //row.grandTotalValue = prevTotal;

    prevData[rowIndex] = row;
    setAirlineData((prev) => ({
      ...prev,
      [shipmentIndex]: prevData,
    }));
  };

  const handleDeleteRow = (shipmentIndex, rowIndex) => {
    setAirlineData((prev) => {
      const updated = [...(prev[shipmentIndex] || [])];
      updated.splice(rowIndex, 1);
      return {
        ...prev,
        [shipmentIndex]: updated,
      };
    });
  };

  const handleDeleteShiplineRow = (shipmentIndex, rowIndex) => {
    setShiplineData((prev) => {
      const updated = [...(prev[shipmentIndex] || [])];
      updated.splice(rowIndex, 1);
      return {
        ...prev,
        [shipmentIndex]: updated,
      };
    });
  };

  const rowExpansionTemplate = (rowData) => {
    //console.log("row data value", rowData);
    const itemsWithIds = rowData.rfq_items?.map((item, idx) => ({
      ...item,
      item_id: item.item_id ?? idx + 1,
    }));

    const itemsWithRoadTransportIds =
      rowData.road_transport_summary?.entries?.map((item, idx) => ({
        ...item,
        row_id: item.row_id ?? idx + 1,
      }));

    const isAuctionEnded =
      auctionData?.endTime && new Date() > new Date(auctionData.endTime);

    return (
      <div className="p-3">
        {itemsWithIds && itemsWithIds.length > 0 && (
          <>
            <h5>Items for RFQ #{rowData.rfq_number}</h5>
            <DataTable
              value={itemsWithIds || []}
              className="p-datatable-sm"
              responsiveLayout="scroll"
            >
              <Column field="item_name" header="Item Name" />
              <Column field="quantity" header="Qty" />
              <Column field="unit" header="Unit" />
              <Column field="target_price" header="Target Price" />
              <Column
                header="Vendor Quote"
                body={(itemRow) => {
                  const itemKey = `${rowData.rfq_number}_${itemRow.item_id}`;
                  return (
                    <InputText
                      type="number"
                      value={quotes[itemKey] || ""}
                      disabled={rowData.status?.toLowerCase() === "accepted"}
                      onChange={(e) => {
                        const value = e.target.value;
                        //console.log("value of item vendor is zero::", value);
                        setQuotes((prev) => ({
                          ...prev,
                          [itemKey]: value,
                        }));
                      }}
                      onBlur={(e) => {
                        const value = parseFloat(e.target.value);
                        //console.log("value of item vendor is one::", value);
                        //console.log("checking quotes value::", quotes);
                        const auctionType = rowData.pickup_by_ff?.toLowerCase();
                        const targetPrice = parseFloat(
                          itemRow.target_price || 0,
                        );

                        if (
                          auctionType === "fixed price" &&
                          value !== targetPrice
                        ) {
                          dispatch(
                            toastError({
                              detail: `Fixed price auction — you cannot change the quote.`,
                            }),
                          );
                          return;
                        }

                        if (
                          auctionType === "variable price" &&
                          value >= targetPrice
                        ) {
                          dispatch(
                            toastError({
                              detail: `Variable price auction — quote must be less than ₹${targetPrice}.`,
                            }),
                          );
                          return;
                        }

                        const rfqIndex = rfqs.findIndex(
                          (r) => r.rfq_number === rowData.rfq_number,
                        );
                        if (rfqIndex === -1) return;

                        const updatedRfqs = [...rfqs];
                        const rfq = updatedRfqs[rfqIndex];
                        const itemIndex = rfq.rfq_items.findIndex(
                          (i) => i.item_id === itemRow.item_id,
                        );
                        //console.log("value of item vendor is two::", value);
                        if (itemIndex !== -1) {
                          rfq.rfq_items[itemIndex] = {
                            ...rfq.rfq_items[itemIndex],
                            vendor_quote: value,
                            vendor_id: "1",
                          };
                          updatedRfqs[rfqIndex] = rfq;
                          setRfqs(updatedRfqs);
                        }
                        //console.log("value of item vendor is three::", value);
                        setQuotes((prev) => ({
                          ...prev,
                          [itemKey]: value,
                        }));
                      }}
                    />
                  );
                }}
              />

              {rowData.auction_number && !rowData.hide_current_bid_price && (
                <Column
                  header="Competing Bids"
                  body={(itemRow) => {
                    const itemKey = `${rowData.rfq_number}_${itemRow.item_id}`;
                    const itemBids = competingQuotes[itemKey] || [];

                    const sorted = [...itemBids].sort(
                      (a, b) => a.quoted_price - b.quoted_price,
                    );

                    return (
                      <div className="text-sm">
                        {sorted.length === 0 && "No Bids Yet"}
                        {sorted.slice(0, 3).map((q, i) => (
                          <div key={i}>
                            L{i + 1}: ₹{q.quoted_price}
                          </div>
                        ))}
                      </div>
                    );
                  }}
                />
              )}

              {rowData.auction_number && rowData.hide_current_bid_price && (
                <Column
                  header="Your Rank"
                  body={(itemRow) => {
                    const key = `${rowData.rfq_number}_${itemRow.item_id}`;
                    const rank = getVendorRank(
                      rowData.rfq_number,
                      itemRow.item_id,
                      user.id,
                      competingQuotes,
                    );
                    return <span>{rank}</span>;
                  }}
                />
              )}
              <Column
                body={() => (
                  <span>
                    {getVendorStatusFromBuyerStatus(
                      rowData.status,
                    ).toUpperCase() || "-"}
                  </span>
                )}
                header="Status"
              />
              <Column
                header="Action"
                body={(itemRow, options) => (
                  <Button
                    label={
                      rowData.auction_number ? "Place Bid" : "Submit Quote"
                    }
                    icon="pi pi-check"
                    className="p-button-success p-button-sm"
                    onClick={() => submitQuote(rowData.rfq_number)}
                    disabled={rowData.status?.toLowerCase() === "accepted"}
                  />
                )}
              />
            </DataTable>
          </>
        )}
        {/* {getVendorStatusFromBuyerStatus(rowData.status) ===
          "QUOTE ACCEPTED" && (
          <div className="mt-3 p-3 border-1 surface-border border-round">
            <h5>📦 Delivery & Invoice Submission</h5>
            <div className="grid formgrid p-fluid">
              <div className="field col-12 md:col-4">
                <label>Delivery Date</label>
                <Calendar
                  value={
                    deliveryDetails[rowData.rfq_number]?.deliveryDate || null
                  }
                  onChange={(e) =>
                    setDeliveryDetails((prev) => ({
                      ...prev,
                      [rowData.rfq_number]: {
                        ...(prev[rowData.rfq_number] || {}),
                        deliveryDate: e.value,
                      },
                    }))
                  }
                  showIcon
                  dateFormat="yy-mm-dd"
                />
              </div>

              <div className="field col-12 md:col-4">
                <label>Total Invoice Amount</label>
                <InputNumber
                  value={
                    deliveryDetails[rowData.rfq_number]?.invoiceAmount || null
                  }
                  onValueChange={(e) =>
                    setDeliveryDetails((prev) => ({
                      ...prev,
                      [rowData.rfq_number]: {
                        ...(prev[rowData.rfq_number] || {}),
                        invoiceAmount: e.value,
                      },
                    }))
                  }
                  mode="currency"
                  currency="INR"
                  locale="en-IN"
                  className="w-full"
                />
              </div>

              <div className="field col-12 md:col-8">
                <label>Delivery Notes</label>
                <InputTextarea
                  value={deliveryDetails[rowData.rfq_number]?.notes || ""}
                  rows={3}
                  onChange={(e) =>
                    setDeliveryDetails((prev) => ({
                      ...prev,
                      [rowData.rfq_number]: {
                        ...(prev[rowData.rfq_number] || {}),
                        notes: e.target.value,
                      },
                    }))
                  }
                />
              </div>

              <div className="field col-12 md:col-6">
                <label>Upload Invoice (PDF)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    setInvoiceFiles((prev) => ({
                      ...prev,
                      [rowData.rfq_number]: e.target.files[0],
                    }))
                  }
                />
              </div>

              <div className="field col-12 md:col-12">
                <Button
                  label="Submit Delivery Details"
                  icon="pi pi-check"
                  className="p-button-success"
                  onClick={() => handleDeliverySubmit(rowData.rfq_number)}
                />
              </div>
            </div>
          </div>
        )} */}

        {rowData.subindustry === "Road Transport" && (
          <>
            <h5 className="mt-3">🚚 Road Transport Details</h5>
            <DataTable
              value={itemsWithRoadTransportIds || []}
              responsiveLayout="scroll"
              className="p-datatable-sm mt-2"
            >
              <Column field="source" header="Source" />
              <Column field="destination" header="Destination" />
              <Column field="loadingBy" header="Loading By" />
              <Column field="unloadingBy" header="Unloading By" />
              <Column field="material" header="Material" />
              <Column
                header="Requirement"
                body={(row) => `${row.requirement} ${row.requirementUnit}`}
              />
              <Column
                header="Material Weight"
                body={(row) => `${row.materialWeight} ${row.materialUnit}`}
              />
              <Column field="vehicleType" header="Vehicle Type" />
              <Column
                field="dateTime"
                header="Date"
                body={(row) => new Date(row.dateTime).toLocaleString()}
              />
              <Column
                header="Distance"
                body={(row) => `${row.distance} ${row.distanceUnit}`}
              />
              <Column field="auctionPrice" header="Auction Price (₹)" />
              <Column field="lastPrice" header="Last Price (₹)" />
              <Column field="decrement" header="Decrement (₹)" />
              {/* <Column field="notes" header="Notes" /> */}

              <Column
                header="Vendor Quote (₹)"
                body={(row) => {
                  const rowKey = `${rowData.rfq_number}_${row.row_id}`;
                  return (
                    <InputText
                      type="number"
                      className="w-full"
                      value={roadTransportQuotes[rowKey] || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setRoadTransportQuotes((prev) => ({
                          ...prev,
                          [rowKey]: value,
                        }));
                      }}
                      onBlur={(e) => {
                        const value = parseFloat(e.target.value);
                        const updatedRfqs = [...rfqs];
                        const rfqIndex = updatedRfqs.findIndex(
                          (r) => r.rfq_number === rowData.rfq_number,
                        );
                        if (rfqIndex === -1) return;

                        const entryIndex = updatedRfqs[
                          rfqIndex
                        ].road_transport_summary.entries.findIndex(
                          (_, idx) => idx === row.row_id,
                        );
                        if (entryIndex !== -1) {
                          updatedRfqs[rfqIndex].road_transport_summary.entries[
                            entryIndex
                          ] = {
                            ...updatedRfqs[rfqIndex].road_transport_summary
                              .entries[entryIndex],
                            vendor_quote: value,
                            vendor_id: user.id,
                          };
                          setRfqs(updatedRfqs);
                        }
                      }}
                    />
                  );
                }}
              />

              <Column
                header="Actions"
                body={(row, options) => (
                  <Button
                    icon="pi pi-check"
                    label="Place Quote"
                    className="p-button-sm p-button-success"
                    onClick={() =>
                      handleRoadTransportQuoteSubmit(rowData.rfq_number)
                    }
                  />
                )}
              />
            </DataTable>
          </>
        )}
        {rowData.subindustry == "Ocean Freight" && (
          <>
            {rowData.shipment_details?.map((shipment, shipmentIndex) => (
              <div className="surface-100 p-3 border-round mt-2 mb-3">
                <div className="p-grid">
                  <span className="p-col-4">
                    <strong>REGION:</strong> {shipment.REGION}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>FPD:</strong> {shipment.FPD}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>CargoType:</strong> {shipment.CargoType}
                  </span>

                  <span className="p-col-4 pl-4">
                    <strong>Equipment Size:</strong> {shipment.EquipmentSize}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>Delivery Type Incoterms:</strong>{" "}
                    {shipment.DeliveryTypeIncoterms}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>CargoWt MT:</strong> {shipment["FF Pickup"]}
                  </span>

                  <span className="p-col-4 pl-4">
                    <strong>Free Days At Destination:</strong>{" "}
                    {shipment.FreeDaysAtDestination}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>HS Code:</strong> {shipment["HS Code"]}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>Monthly Volume:</strong> {shipment.MonthlyVolume}
                  </span>

                  <span className="p-col-4 pl-4">
                    <strong>Condition:</strong> {shipment.Condition}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>cargo Type:</strong> {rowData.cargoType}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>Value of Shipment:</strong> ₹
                    {shipment.package_summary?.value_of_shipment || 0}
                  </span>

                  <span className="p-col-4 pl-4">
                    <strong>Currency:</strong>{" "}
                    {shipment.package_summary?.shipment_currency}
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>Gross Wt:</strong>{" "}
                    {shipment.package_summary?.totalGrossWeight} kg
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>Vol. Wt:</strong>{" "}
                    {shipment.package_summary?.totalVolumetricWeight} kg
                  </span>

                  <span className="p-col-4 pl-4">
                    <strong>Chargeable Wt:</strong>{" "}
                    {shipment.package_summary?.chargeableWeight} kg
                  </span>
                  <span className="p-col-4 pl-4">
                    <strong>CBM:</strong> {shipment.package_summary?.totalCBM}
                  </span>
                  <div className="p-col-12 text-right mt-3">
                    <Button
                      icon="pi pi-send"
                      label="Submit Quote"
                      className="p-button-success mt-3"
                      onClick={() =>
                        handleShiplinePackageSubmit(shipmentIndex, rowData)
                      }
                    />
                    <Button
                      label="Add Shipline"
                      icon="pi pi-plus"
                      className="p-button-sm p-button-secondary"
                      onClick={() => handleAddShipline(shipmentIndex)}
                    />
                  </div>
                </div>

                {(shiplineData[shipmentIndex] || []).map((row, idx) => (
                  <div
                    className="grid p-2 align-items-center mt-3 border-top-3 border-bottom-3 surface-border"
                    key={idx}
                  >
                    <div className="col-2 p-1">
                      <label>Shipline Name</label>
                      <InputText
                        value={row.sealine_name}
                        className="w-full"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "sealine_name",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-2 p-1">
                      <label>Seaport</label>
                      <InputText
                        value={row.sea_port}
                        className="w-full"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "sea_port",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-2 p-1">
                      <label>Freight Per Cont</label>
                      <InputText
                        value={row.freight_per_container}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "freight_per_container",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>Temperature</label>
                      <InputText
                        value={row.temperature}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "temperature",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>DAP / DDP</label>
                      <InputText
                        value={row.dap_ddp}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "dap_ddp",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>Transit Time</label>
                      <InputText
                        value={row.transit_time}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "transit_time",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-2 p-1">
                      <label>Freight Per CBM</label>
                      <InputText
                        value={row.freight_per_cbm}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "freight_per_cbm",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-2 p-1">
                      <label>Origin Charges</label>
                      <InputText
                        value={row.origin_charges}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "origin_charges",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Destination Charges</label>
                      <InputText
                        value={row.destination_charges}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "destination_charges",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>Remarks</label>
                      <InputText
                        value={row.remarks}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "remarks",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>Rate Validity</label>
                      <InputText
                        value={row.rate_validity}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "rate_validity",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="col-1 p-1">
                      <label>All In Freight</label>
                      <InputText
                        value={row.all_in_freight}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "all_in_freight",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>THC</label>
                      <InputText
                        value={row.thc}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "thc",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>BL Fee</label>
                      <InputText
                        value={row.blFee}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "blFee",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>ENS ACD Fee</label>
                      <InputText
                        value={row.ensAcdFee}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "ensAcdFee",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Other Charges</label>
                      <InputText
                        value={row.other_charges}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "other_charges",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>Haulage</label>
                      <InputText
                        value={row.haulage}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "haulage",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Customs Clearance</label>
                      <InputText
                        value={row.customs_clearance}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "customs_clearance",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>ISF</label>
                      <InputText
                        value={row.isf}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "isf",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>DTHC</label>
                      <InputText
                        value={row.dthc}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "dthc",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>DODDC</label>
                      <InputText
                        value={row.doDdc}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "doDdc",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>HMF</label>
                      <InputText
                        value={row.hmf}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "hmf",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>MPE</label>
                      <InputText
                        value={row.mpe}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "mpe",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>PrePull</label>
                      <InputText
                        value={row.prePull}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "prePull",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Other Destination Charges</label>
                      <InputText
                        value={row.other_destination_charges}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "other_destination_charges",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Origin Detention</label>
                      <InputText
                        value={row.origin_detention}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "origin_detention",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Destination Detention</label>
                      <InputText
                        value={row.destination_detention}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "destination_detention",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Destination Combine</label>
                      <InputText
                        value={row.destination_combine}
                        className="w-full"
                        type="number"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "destination_combine",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Shipping Line</label>
                      <InputText
                        value={row.shipping_line}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "shipping_line",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      <label>Transit Time</label>
                      <InputText
                        value={row.transit_time}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "transit_time",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>Routing</label>
                      <InputText
                        value={row.routing}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "routing",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>Validity</label>
                      <InputText
                        value={row.validity}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "validity",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-1 p-1">
                      <label>Total</label>
                      <InputText
                        value={row.total_charges}
                        className="w-full"
                        type="text"
                        onChange={(e) =>
                          handleSealineInputChange(
                            shipment,
                            shipmentIndex,
                            idx,
                            "total_charges",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div className="col-2 p-1">
                      {/* <Button
                        icon="pi pi-angle-down"
                        className="p-button-text p-button-secondary"
                        onClick={() => toggleMoreInfo(shipmentIndex, idx)}
                        tooltip="More Info"
                      /> */}
                      <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-danger"
                        onClick={() =>
                          handleDeleteShiplineRow(shipmentIndex, idx)
                        }
                      />
                    </div>
                  </div>
                ))}

                <DataTable
                  value={shipment.package_summary?.packages || []}
                  responsiveLayout="scroll"
                  className="p-datatable-sm"
                >
                  <Column field="type" header="Package Type" />
                  <Column field="number" header="No. of Pkgs" />
                  <Column field="length" header="Length (cm)" />
                  <Column field="breadth" header="Breadth (cm)" />
                  <Column field="height" header="Height (cm)" />
                  <Column field="gross_weight" header="Gross Wt (kg)" />

                  <Column
                    header="Action"
                    body={(pkg, options) => {
                      const rowIndex = options.rowIndex;
                      return (
                        <Button
                          style={{ display: "none" }}
                          label="Place Quote"
                          icon="pi pi-check"
                          className="p-button-sm p-button-success"
                          onClick={() =>
                            handlePackageSubmit(
                              shipmentIndex,
                              rowIndex,
                              rowData,
                            )
                          }
                        />
                      );
                    }}
                  />
                </DataTable>
              </div>
            ))}
          </>
        )}
        {rowData.subindustry == "Air Cargo" && (
          <div>
            {rowData.shipment_details?.map((shipment, shipmentIndex) => (
              <div key={shipmentIndex} className="mb-4">
                <h5 className="mt-4">✈️ Shipment {shipmentIndex + 1}</h5>
                <div className="surface-100 p-3 border-round mt-2 mb-3">
                  <div className="p-grid">
                    <span className="p-col-4">
                      <strong>Temp:</strong> {shipment.Temp}°C
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>Country:</strong> {rowData.country}
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>Factory:</strong> {shipment.Factory}
                    </span>

                    <span className="p-col-4 pl-4">
                      <strong>Clearance:</strong> {shipment.Clearance}
                    </span>
                    {/* <span className="p-col-4 pl-4">
                      <strong>Delivery Terms:</strong> {shipment.DeliveryTerms}
                    </span> */}
                    <span className="p-col-4 pl-4">
                      <strong>FF Pickup:</strong> {shipment.FFPickup}
                    </span>

                    <span className="p-col-4 pl-4">
                      <strong>Commodity:</strong> {shipment.Commodity}
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>HS Code:</strong> {shipment.HSCode}
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>Consignee:</strong> {shipment.Consignee}
                    </span>

                    <span className="p-col-4 pl-4">
                      <strong>Incoterm:</strong> {rowData.incoterm}
                    </span>
                    {/* <span className="p-col-4 pl-4">
                      <strong>Notes:</strong> {shipment.Notes}
                    </span> */}
                    <span className="p-col-4 pl-4">
                      <strong>Value of Shipment:</strong> ₹
                      {shipment.package_summary?.value_of_shipment || 0}
                    </span>

                    <span className="p-col-4 pl-4">
                      <strong>Currency:</strong>{" "}
                      {shipment.package_summary?.shipment_currency}
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>Gross Wt:</strong>{" "}
                      {shipment.package_summary?.totalGrossWeight} kg
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>Vol. Wt:</strong>{" "}
                      {shipment.package_summary?.totalVolumetricWeight} kg
                    </span>

                    <span className="p-col-4 pl-4">
                      <strong>Chargeable Wt:</strong>{" "}
                      {shipment.package_summary?.chargeableWeight} kg
                    </span>
                    <span className="p-col-4 pl-4">
                      <strong>CBM:</strong> {shipment.package_summary?.totalCBM}
                    </span>

                    {quoteAcceptedData && quoteAcceptedData.accepted_at && (
                      <div
                        className="p-3 mt-5 border-round shadow-2 mb-3 flex align-items-center justify-content-between"
                        style={{
                          background:
                            "linear-gradient(90deg, #d4edda 0%, #c3e6cb 100%)",
                          borderLeft: "6px solid #28a745",
                          color: "#155724",
                          fontWeight: "bold",
                        }}
                      >
                        <div className="flex align-items-center">
                          <span
                            role="img"
                            aria-label="trophy"
                            style={{
                              fontSize: "2rem",
                              marginRight: "12px",
                              filter: "drop-shadow(1px 1px 2px #999)",
                            }}
                          >
                            🏆
                          </span>
                          <div>
                            <div style={{ fontSize: "1.2rem" }}>
                              🎉 Your Quote Has Been Accepted!
                            </div>
                            <div
                              style={{
                                fontSize: "1rem",
                                opacity: 0.9,
                                marginTop: "10px",
                              }}
                            >
                              Accepted on:{" "}
                              {quoteAcceptedData.accepted_at
                                ? new Date(
                                    quoteAcceptedData.accepted_at,
                                  ).toLocaleString()
                                : "N/A"}
                            </div>
                            <div
                              style={{
                                fontSize: "1rem",
                                opacity: 0.9,
                                marginTop: "10px",
                              }}
                            >
                              Accepted Airline:{" "}
                              {quoteAcceptedData.accepted_airline
                                ? quoteAcceptedData.accepted_airline
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {rowData.status === "accepted" &&
                      quoteAcceptedData.vendor_id !== user.id && (
                        <div
                          className="p-3 mt-5 border-round shadow-2 mb-3 flex align-items-center justify-content-between"
                          style={{
                            background:
                              "linear-gradient(90deg, #f8d7da 0%, #f5c6cb 100%)", // soft red gradient
                            borderLeft: "6px solid #dc3545", // red accent
                            color: "#721c24",
                            fontWeight: "bold",
                          }}
                        >
                          <div className="flex align-items-center">
                            <span
                              role="img"
                              aria-label="info"
                              style={{
                                fontSize: "2rem",
                                marginRight: "12px",
                                filter: "drop-shadow(1px 1px 2px #999)",
                              }}
                            >
                              🚫
                            </span>

                            <div>
                              <div style={{ fontSize: "1.2rem" }}>
                                ❗ This Auction Has Been Closed
                              </div>
                              <div
                                style={{
                                  fontSize: "1rem",
                                  opacity: 0.9,
                                  marginTop: "10px",
                                }}
                              >
                                Another vendor’s quote has been accepted for
                                this auction.
                              </div>
                              <div
                                style={{
                                  fontSize: "1rem",
                                  opacity: 0.9,
                                  marginTop: "10px",
                                }}
                              >
                                We appreciate your participation — stay tuned
                                for upcoming auctions and future opportunities!
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    {/* {negotiationData.last_purchase_price && (
                      <div className="p-col-12 mt-3">
                        <div className="p-3 border-1 border-round surface-100 shadow-1">
                          <h4 className="m-0 mb-2 text-primary">
                            Negotiation Request Details
                          </h4>
                          <div className="text-sm">
                            <p className="m-1">
                              <strong>Airline Name:</strong>{" "}
                              {negotiationData.airline_name || "N/A"}
                            </p>
                            <p className="m-1">
                              <strong>
                                Last Purchase Price (LPP) / Target Price:
                              </strong>{" "}
                              {negotiationData.last_purchase_price || "N/A"}
                            </p>
                            <p className="m-1">
                              <strong>Reason:</strong>{" "}
                              {negotiationData.remarks || "N/A"}
                            </p>
                            <p className="m-1">
                              <strong>Date:</strong>{" "}
                              {negotiationData.requested_at
                                ? new Date(
                                    negotiationData.requested_at
                                  ).toLocaleString()
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>
                    )} */}

                    {Array.isArray(negotiationData) &&
                      negotiationData.length > 0 && (
                        <div className="grid mt-3">
                          {negotiationData.map((item, index) => (
                            <div
                              key={index}
                              className="col-12 md:col-6 lg:col-4"
                            >
                              <div className="p-3 border-1 border-round surface-100 shadow-1 h-full">
                                <h5 className="text-primary mb-2">
                                  {item.airline_name || "Unknown Airline"}
                                </h5>
                                <p className="m-1">
                                  <strong>Target Price:</strong>{" "}
                                  {item.last_purchase_price || "N/A"}
                                </p>
                                <p className="m-1">
                                  <strong>Reason:</strong>{" "}
                                  {item.remarks || "N/A"}
                                </p>
                                <p className="m-1">
                                  <strong>Date:</strong>{" "}
                                  {item.requested_at
                                    ? new Date(
                                        item.requested_at,
                                      ).toLocaleString()
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                    <div className="p-col-12 text-right mt-3">
                      {/* <Button
                        icon="pi pi-send"
                        label="Participate in Auction"
                        className="p-button-success mt-3 mr-4"
                        onClick={() => setShowVendorAuctionDialog(true)}
                      /> */}
                      {!auctionData && (
                        <Button
                          icon="pi pi-send"
                          label="Submit Quote"
                          className="p-button-success mt-3 mr-4"
                          disabled={
                            rowData.status === "accepted" ||
                            !airlineData[shipmentIndex] ||
                            airlineData[shipmentIndex].length === 0 ||
                            (rowData.close_date_time &&
                              new Date(rowData.close_date_time) < new Date())
                          }
                          onClick={() =>
                            handlePackageSubmit(shipmentIndex, rowData)
                          }
                        />
                      )}

                      {/* <Button
                        label="Add Airline"
                        icon="pi pi-plus"
                        className="p-button-sm p-button-secondary"
                        disabled={rowData.status == "accepted"}
                        onClick={() => handleAddAirline(shipmentIndex)}
                      /> */}
                      <Button
                        label="Add Airline"
                        icon="pi pi-plus"
                        className="p-button-sm p-button-secondary"
                        disabled={
                          (rowData.close_date_time &&
                            new Date(rowData.close_date_time) < new Date()) ||
                          rowData.status === "accepted" ||
                          (!rowData.allow_multiple_airline_quote &&
                            (airlineData?.[shipmentIndex]?.length || 0) >= 1)
                        }
                        onClick={() => handleAddAirline(shipmentIndex)}
                      />
                    </div>
                  </div>
                </div>

                {(airlineData[shipmentIndex] || []).map((row, idx) => (
                  <div
                    key={idx}
                    className="p-3 mb-3 border-1 border-round surface-100 shadow-1"
                  >
                    <h4 className="mb-3">Airline Entry {idx + 1}</h4>

                    {/* Basic Details */}
                    <div className="grid formgrid p-fluid">
                      <div
                        className={`col-12 md:col-${
                          !auctionData?.auction_number ? 8 : 8
                        }`}
                      >
                        <fieldset disabled={isAuctionEnded}>
                          <div className="grid formgrid">
                            <div className="field col-12 md:col-4">
                              <label>Airline</label>
                              <InputText
                                value={row.airline_name}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "airline_name",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>Airport</label>
                              <InputText
                                value={row.airport}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "airport",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>Chargeable Weight (KG)</label>
                              <InputNumber
                                value={row.chargeable_weight || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "chargeable_weight",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>Freight (Rs/KG)</label>
                              <InputNumber
                                value={row.base_rate || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "base_rate",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>AMS (CURRENCY-INR)</label>
                              <InputNumber
                                value={row.ams || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "ams",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>PAC (CURRENCY-INR)</label>
                              <InputNumber
                                value={row.pac || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "pac",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>AWB (CURRENCY-INR)</label>
                              <InputNumber
                                value={row.awb || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "awb",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>Other Charges (CURRENCY-INR)</label>
                              <InputNumber
                                value={row.other_charges || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "other_charges",
                                    e.value,
                                  )
                                }
                              />
                            </div>

                            <div className="field col-12 md:col-4">
                              <label>
                                <b>Total</b>
                              </label>
                              <InputNumber
                                value={row.total_charges || 0}
                                readOnly
                                onChange={(e) =>
                                  handleInputChange(
                                    shipment,
                                    shipmentIndex,
                                    idx,
                                    "total_charges",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            {JSON.stringify(rowData?.dapCurrency ?? "") !==
                              '""' && (
                              <div className="field col-12 md:col-4">
                                <label>Currency</label>
                                <Dropdown
                                  value={row.currency || "INR"}
                                  options={currencyExchangeRates.map(
                                    (item) => item.currency,
                                  )}
                                  onChange={(e) =>
                                    handleCurrencyChangeNew(
                                      shipment,
                                      shipmentIndex,
                                      idx,
                                      "currency",
                                      e.value,
                                    )
                                  }
                                />
                              </div>
                            )}

                            {JSON.stringify(rowData?.dapCurrency ?? "") !==
                              '""' && (
                              <div className="field col-12 md:col-2">
                                <label>Exchange Rate</label>
                                <InputNumber
                                  value={row.exchangeRate || 0}
                                  mode="decimal"
                                  disabled
                                  minFractionDigits={3}
                                  onChange={(e) =>
                                    handleExchangeRateChange(
                                      shipment,
                                      shipmentIndex,
                                      idx,
                                      "exchangeRate",
                                      e.value,
                                    )
                                  }
                                />
                                <span>{fetchingRateMsg}</span>
                              </div>
                            )}

                            {JSON.stringify(rowData?.dapCurrency ?? "") !==
                              '""' && (
                              <div className="field col-12 md:col-2">
                                <label>DAP/DDP</label>

                                <InputNumber
                                  value={row.dap_ddp_charges || 0}
                                  onChange={(e) => {
                                    console.log("onChange:", e.value);
                                    handleDapDdpChange(
                                      shipment,
                                      shipmentIndex,
                                      idx,
                                      "dap_ddp_charges",
                                      e.value,
                                    );
                                  }}
                                />
                              </div>
                            )}

                            {JSON.stringify(rowData?.dapCurrency ?? "") !==
                              '""' && (
                              <div className="field col-12 md:col-4">
                                <label>
                                  <b>Total DAP/DPP Charge</b>
                                </label>
                                <InputNumber
                                  value={row.totaldapdppcharge || 0}
                                  readOnly
                                />
                              </div>
                            )}

                            <div className="field col-12 md:col-4">
                              <label>
                                <b>Grand Total</b>
                              </label>
                              <InputNumber
                                value={row.grandTotalValue || 0}
                                readOnly
                              />
                            </div>
                          </div>
                        </fieldset>

                        {/* {row.hodAcceptRequestDetails?.requested_airline && (
                          <div
                            className={`p-3 mt-3 border-round ${
                              row.hodAcceptRequestDetails?.hod_rejected_on
                                ? "bg-red-50 border-red-300"
                                : "bg-green-50 border-green-300"
                            }`}
                          >
                            {row.hodAcceptRequestDetails?.hod_rejected_on && (
                              <div
                                style={{
                                  marginTop: "12px",
                                  padding: "10px",
                                  backgroundColor: "#fff3cd",
                                  border: "1px solid #ffeeba",
                                  borderRadius: "4px",
                                  color: "#856404",
                                }}
                              >
                                <strong
                                  className={
                                    row.hodAcceptRequestDetails?.hod_rejected_on
                                      ? "text-red-700"
                                      : "text-green-700"
                                  }
                                >
                                  Note :
                                  {row.hodAcceptRequestDetails?.hod_rejected_on
                                    ? "Buyer Rejected"
                                    : ""}
                                </strong>
                                <br />
                                <strong>Rejected On:</strong>{" "}
                                {formatDate(
                                  row.hodAcceptRequestDetails.hod_rejected_on,
                                )}
                                <br />
                                <strong>Buyer Comment:</strong>{" "}
                                {row.hodAcceptRequestDetails.hod_msg}
                              </div>
                            )}

                            {!row?.hodAcceptRequestDetails?.hod_rejected_on &&
                              row?.hodAcceptRequestDetails?.hod_approved_on &&
                              !row?.flight_schedule1 &&
                              row?.buyerDocumentsUploadedDetails.attached_file
                                ?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    padding: "10px",
                                    backgroundColor: "#fff3cd",
                                    border: "1px solid #ffeeba",
                                    borderRadius: "4px",
                                    color: "#856404",
                                  }}
                                >
                                  <strong
                                    className={
                                      row.hodAcceptRequestDetails
                                        ?.hod_rejected_on
                                        ? "text-red-700"
                                        : "text-green-700"
                                    }
                                  >
                                    {row.hodAcceptRequestDetails
                                      ?.hod_rejected_on
                                      ? "Buyer Rejected"
                                      : "Buyer Approved"}
                                  </strong>
                                  <div style={{ marginTop: "8px" }}>
                                    <strong>Buyer Comment:</strong>{" "}
                                    {row.hodAcceptRequestDetails.hod_msg}
                                    <br />
                                    {row.hodAcceptRequestDetails
                                      ?.hod_rejected_on ? (
                                      <>
                                        <strong>Rejected On:</strong>{" "}
                                        {formatDate(
                                          row.hodAcceptRequestDetails
                                            .hod_rejected_on,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <strong>Buyer Approved On:</strong>{" "}
                                        {formatDate(
                                          row.hodAcceptRequestDetails
                                            .hod_approved_on,
                                        )}
                                      </>
                                    )}
                                  </div>
                                  <strong>Note:</strong> You are nominated for
                                  this shipment, kindly share earliest flight
                                  schedule.
                                </div>
                              )}

                            {row?.flight_schedule1 &&
                              row?.hodAcceptRequestDetails?.hod_approved_on &&
                              !row?.invoiceDetails &&
                              Object.keys(
                                row?.buyerDocumentsUploadedDetails || {},
                              ).length > 0 && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    padding: "10px",
                                    backgroundColor: "#fff3cd",
                                    border: "1px solid #ffeeba",
                                    borderRadius: "4px",
                                    color: "#856404",
                                  }}
                                >
                                  <strong>Note:</strong> Flight schedule has
                                  been submitted. Kindly upload the invoice and
                                  related cost documents (Freight, DAP, Custom
                                  Duty, Others) at the earliest to proceed
                                  further.
                                </div>
                              )}

                            <br />

                            {row?.hodAcceptRequestDetails?.hod_approved_on &&
                              Object.keys(
                                row?.buyerDocumentsUploadedDetails || {},
                              ).length > 0 && (
                                <>
                                  <div style={{ marginTop: "8px" }}>
                                    <strong>Buyer Comment:</strong>{" "}
                                    {row.hodAcceptRequestDetails.hod_msg}
                                    <br />
                                    {row.hodAcceptRequestDetails
                                      ?.hod_rejected_on ? (
                                      <>
                                        <strong>Rejected On:</strong>{" "}
                                        {formatDate(
                                          row.hodAcceptRequestDetails
                                            .hod_rejected_on,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <strong>Buyer Approved On:</strong>{" "}
                                        {formatDate(
                                          row.hodAcceptRequestDetails
                                            .hod_approved_on,
                                        )}
                                      </>
                                    )}
                                  </div>
                                  <strong>Note:</strong> You are nominated for
                                  this shipment, kindly share earliest flight
                                  schedule.
                                  <br />
                                  <Button
                                    label="Upload Invoice"
                                    icon="pi pi-upload"
                                    className="p-button-sm"
                                    onClick={() => {
                                      setSelectedRow({
                                        user,
                                        rfqNumberForQuoteSummary,
                                        invoiceDetails:
                                          row.invoiceDetails || [],
                                      });
                                      setShowVendorUpload(true);
                                    }}
                                  />
                                </>
                              )}
                          </div>
                        )} */}

                        {row.hodAcceptRequestDetails?.requested_airline &&
                          row.hodAcceptRequestDetails?.requested_airline ===
                            row.airline_name &&
                          row.buyerDocumentsUploadedDetails?.submitted_at &&
                          row.buyerDocumentsUploadedDetails?.airline_name ===
                            row.airline_name && (
                            <div
                              className={`mt-4 border-round-xl shadow-2 overflow-hidden border-1 ${
                                row.hodAcceptRequestDetails?.hod_rejected_on
                                  ? "border-red-200 bg-red-50"
                                  : "border-green-200 bg-green-50"
                              }`}
                            >
                              {/* HEADER */}
                              <div
                                className="flex justify-content-between align-items-center px-4 py-3"
                                style={{
                                  background: row.hodAcceptRequestDetails
                                    ?.hod_rejected_on
                                    ? "#fee2e2"
                                    : "#dcfce7",
                                }}
                              >
                                <div className="flex align-items-center gap-3">
                                  <i
                                    className={`pi ${
                                      row.hodAcceptRequestDetails
                                        ?.hod_rejected_on
                                        ? "pi-times-circle text-red-600"
                                        : "pi-check-circle text-green-600"
                                    }`}
                                    style={{
                                      fontSize: "1.6rem",
                                    }}
                                  />

                                  <div>
                                    <div
                                      style={{
                                        fontWeight: 700,
                                        fontSize: "1rem",
                                        color: "#1e293b",
                                      }}
                                    >
                                      {row.hodAcceptRequestDetails
                                        ?.hod_rejected_on
                                        ? "Buyer Rejected"
                                        : "Buyer Approved"}
                                    </div>

                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#64748b",
                                        marginTop: "2px",
                                      }}
                                    >
                                      Shipment Approval Workflow
                                    </div>
                                  </div>
                                </div>

                                <span
                                  className={`px-3 py-2 border-round text-sm font-semibold ${
                                    row.hodAcceptRequestDetails?.hod_rejected_on
                                      ? "bg-red-100 text-red-700"
                                      : "bg-green-100 text-green-700"
                                  }`}
                                >
                                  {row.hodAcceptRequestDetails?.hod_rejected_on
                                    ? "Rejected"
                                    : "Approved"}
                                </span>
                              </div>

                              {/* BODY */}
                              <div className="p-4">
                                <div className="grid">
                                  {/* APPROVAL DETAILS */}
                                  <div className="col-12 md:col-6">
                                    <div
                                      className="h-full border-round-lg p-3"
                                      style={{
                                        background: "#ffffff",
                                        border: "1px solid #e2e8f0",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "10px",
                                          fontSize: "14px",
                                          lineHeight: 1.7,
                                        }}
                                      >
                                        <strong>Submitted On:</strong>
                                        {formatDate(
                                          row.buyerDocumentsUploadedDetails
                                            .submitted_at,
                                        )}
                                        <br />
                                        {row.buyerDocumentsUploadedDetails
                                          .attached_file?.length > 0 && (
                                          <>
                                            <strong>Attachments:</strong>

                                            {row.buyerDocumentsUploadedDetails.attached_file.map(
                                              (file, index) => (
                                                <div key={index}>
                                                  <a
                                                    href={`${BASE_URL}/uploads/rfq/${encodeURIComponent(file)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-700 underline"
                                                  >
                                                    {file}
                                                  </a>
                                                </div>
                                              ),
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* WORKFLOW STATUS */}
                                  <div className="col-12 md:col-6">
                                    <div
                                      className="h-full border-round-lg p-3"
                                      style={{
                                        background: "#ffffff",
                                        border: "1px solid #e2e8f0",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          marginBottom: "12px",
                                          color: "#334155",
                                          fontSize: "15px",
                                        }}
                                      >
                                        Shipment Workflow Status
                                      </div>

                                      {/* REJECTED NOTE */}
                                      {row.hodAcceptRequestDetails
                                        ?.hod_rejected_on && (
                                        <div
                                          style={{
                                            padding: "12px",
                                            borderRadius: "8px",
                                            background: "#fef2f2",
                                            border: "1px solid #fecaca",
                                            color: "#991b1b",
                                            lineHeight: 1.8,
                                            fontSize: "14px",
                                          }}
                                        >
                                          <strong>Note:</strong> Buyer Rejected
                                          <div
                                            style={{
                                              padding: "12px",
                                              borderRadius: "8px",
                                              background: "#fffbeb",
                                              border: "1px solid #fde68a",
                                              color: "#92400e",
                                              lineHeight: 1.8,
                                              fontSize: "14px",
                                            }}
                                          >
                                            <strong>Note:</strong>{" "}
                                            {
                                              row.hodAcceptRequestDetails
                                                .hod_msg
                                            }
                                          </div>
                                        </div>
                                      )}

                                      {!row?.hodAcceptRequestDetails
                                        ?.hod_rejected_on &&
                                        row.hodAcceptRequestDetails
                                          ?.hod_approved_on && (
                                          <div
                                            style={{
                                              padding: "12px",
                                              borderRadius: "8px",
                                              background: "#fffbeb",
                                              border: "1px solid #fde68a",
                                              color: "#92400e",
                                              lineHeight: 1.8,
                                              fontSize: "14px",
                                            }}
                                          >
                                            <strong>Note:</strong> You are
                                            nominated for this shipment, kindly
                                            share earliest flight schedule.
                                          </div>
                                        )}

                                      {/* FLIGHT SCHEDULE SUBMITTED */}
                                      {row?.flight_schedule1 &&
                                        row?.hodAcceptRequestDetails
                                          ?.hod_approved_on &&
                                        !row?.invoiceDetails &&
                                        Object.keys(
                                          row?.buyerDocumentsUploadedDetails ||
                                            {},
                                        ).length > 0 && (
                                          <div
                                            style={{
                                              padding: "12px",
                                              borderRadius: "8px",
                                              background: "#eff6ff",
                                              border: "1px solid #bfdbfe",
                                              color: "#1e40af",
                                              lineHeight: 1.8,
                                              fontSize: "14px",
                                            }}
                                          >
                                            <strong>Note:</strong> Flight
                                            schedule has been submitted. Kindly
                                            upload the invoice and related cost
                                            documents (Freight, DAP, Custom
                                            Duty, Others) at the earliest to
                                            proceed further.
                                          </div>
                                        )}

                                      {/* UPLOAD INVOICE */}
                                      {row?.hodAcceptRequestDetails
                                        ?.hod_approved_on &&
                                        Object.keys(
                                          row?.buyerDocumentsUploadedDetails ||
                                            {},
                                        ).length > 0 && (
                                          <div className="mt-4">
                                            <Button
                                              label="Upload Invoice"
                                              icon="pi pi-upload"
                                              className="p-button-sm p-button-success"
                                              onClick={() => {
                                                setSelectedRow({
                                                  user,
                                                  rfqNumberForQuoteSummary,
                                                  invoiceDetails:
                                                    row.invoiceDetails || [],
                                                });

                                                setShowVendorUpload(true);
                                              }}
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        <div className="grid">
                          {/* Buyer Documents Card */}
                          {row?.buyerDocumentsUploadedDetails &&
                            row.airline_name ===
                              row.buyerDocumentsUploadedDetails
                                .airline_name && (
                              <div className="col-12 md:col-6">
                                <div className="p-3 mt-3 border-round bg-blue-50 border-blue-300">
                                  <div className="flex justify-content-between align-items-center">
                                    <strong className="text-blue-700">
                                      Buyer Documents Submitted
                                    </strong>

                                    <span className="px-2 py-1 border-round text-sm bg-green-100 text-green-700">
                                      {row.buyerDocumentsUploadedDetails.status}
                                    </span>
                                  </div>

                                  <div style={{ marginTop: "8px" }}>
                                    <strong>Vendor:</strong>{" "}
                                    {
                                      row.buyerDocumentsUploadedDetails
                                        .vendor_name
                                    }
                                    <br />
                                    <strong>Vendor Email:</strong>{" "}
                                    {
                                      row.buyerDocumentsUploadedDetails
                                        .vendor_email
                                    }
                                    <br />
                                    <strong>Airline:</strong>{" "}
                                    {
                                      row.buyerDocumentsUploadedDetails
                                        .airline_name
                                    }
                                    <br />
                                    <strong>Submitted On:</strong>{" "}
                                    {formatDate(
                                      row.buyerDocumentsUploadedDetails
                                        .submitted_at,
                                    )}
                                    <br />
                                    {row.buyerDocumentsUploadedDetails
                                      .attached_file?.length > 0 && (
                                      <>
                                        <strong>Attachments:</strong>

                                        {row.buyerDocumentsUploadedDetails.attached_file.map(
                                          (file, index) => (
                                            <div key={index}>
                                              <a
                                                href={`${BASE_URL}/uploads/rfq/${encodeURIComponent(file)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-700 underline"
                                              >
                                                {file}
                                              </a>
                                            </div>
                                          ),
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                <Button
                                  label="Upload Invoice"
                                  icon="pi pi-upload"
                                  className="p-button-sm p-button-success"
                                  onClick={() => {
                                    setSelectedRow({
                                      user,
                                      rfqNumberForQuoteSummary,
                                      invoiceDetails: row.invoiceDetails || [],
                                    });

                                    setShowVendorUpload(true);
                                  }}
                                />
                              </div>
                            )}

                          {/* Invoice Details Card */}
                          {row?.invoiceDetails?.status &&
                            row.buyerDocumentsUploadedDetails?.airline_name ===
                              row.airline_name && (
                              <div className="col-12 md:col-6">
                                <div className="p-3 mt-3 border-round bg-green-50 border-green-300">
                                  <div className="flex justify-content-between align-items-center">
                                    <strong className="text-green-700">
                                      Invoice Submitted
                                    </strong>
                                    <span
                                      className={`px-2 py-1 border-round text-sm ${
                                        row.invoiceDetails?.status ===
                                        "invoice_rejected"
                                          ? "bg-red-100 text-red-700"
                                          : row.invoiceDetails?.status ===
                                              "invoice_approved"
                                            ? "bg-green-100 text-green-700"
                                            : "bg-yellow-100 text-yellow-700"
                                      }`}
                                    >
                                      {row.invoiceDetails?.status ===
                                      "invoice_rejected"
                                        ? "Rejected"
                                        : row.invoiceDetails?.status ===
                                            "invoice_approved"
                                          ? "Approved"
                                          : "Submitted"}
                                    </span>
                                  </div>

                                  {row.invoiceDetails?.status ===
                                    "invoice_rejected" &&
                                    row.invoiceDetails?.remarks && (
                                      <div className="mt-2 p-2 border-round bg-red-50 border-red-300">
                                        <strong className="text-red-700">
                                          Rejection Reason:
                                        </strong>
                                        <div className="text-red-600 text-sm mt-1">
                                          {row.invoiceDetails.remarks}
                                        </div>
                                      </div>
                                    )}

                                  <div style={{ marginTop: "8px" }}>
                                    <strong>DAP Amount:</strong>{" "}
                                    {row.invoiceDetails.dap_amount}
                                    <br />
                                    <strong>Freight Amount:</strong>{" "}
                                    {row.invoiceDetails.freight_amount}
                                    <br />
                                    <strong>Custom Duty:</strong>{" "}
                                    {row.invoiceDetails.custom_duty_amount}
                                    <br />
                                    <strong>Other Charges:</strong>{" "}
                                    {row.invoiceDetails.others_amount}
                                    <br />
                                    <strong>Submitted On:</strong>{" "}
                                    {formatDate(
                                      row.invoiceDetails.submitted_on,
                                    )}
                                    <br />
                                    {row.invoiceDetails.attached_file?.length >
                                      0 && (
                                      <>
                                        <strong>Attachments:</strong>

                                        {row.invoiceDetails.attached_file.map(
                                          (file, index) => (
                                            <div key={index}>
                                              <a
                                                href={`${BASE_URL}/uploads/rfq/${encodeURIComponent(file)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-green-700 underline"
                                              >
                                                {file}
                                              </a>
                                            </div>
                                          ),
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>

                      {/* {auctionData?.auction_number && ( */}
                      <div className="col-12 md:col-4">
                        <div
                          style={{
                            border: "1px dashed #cbd5e1",
                            borderRadius: "10px",
                            padding: "0rem",
                            height: "100%",
                            background: "#f8fafc",
                          }}
                        >
                          <VendorBiddingPanel
                            userId={userId}
                            bidValue={row.grandTotalValue}
                            airlineName={row.airline_name}
                            auctionData={auctionData}
                            shipmentIndex={shipmentIndex}
                            rowData={rowData}
                            rfqQuoteRank={getRankForRow(
                              shipmentIndex,
                              row.airline_name,
                            )}
                            onSubmitBid={handlePackageSubmit}
                            onAuctionDataRankUpdate={
                              handleAuctionDataRankUpdate
                            }
                          />
                        </div>
                      </div>
                      {/* )} */}
                    </div>

                    {/* More Info Section - Always Visible */}
                    <div className="grid formgrid p-fluid mt-3 border-top-1 pt-3">
                      <div className="field col-12 md:col-6">
                        <label>Flight Route 1</label>
                        <InputText
                          value={row.route1 || ""}
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "route1",
                              e.target.value,
                            )
                          }
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label>Flight Schedule 1</label>
                        <Calendar
                          value={
                            row.flight_schedule1
                              ? new Date(row.flight_schedule1)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "flight_schedule1",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label>Flight Route 2</label>
                        <InputText
                          value={row.route2 || ""}
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "route2",
                              e.target.value,
                            )
                          }
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label>Flight Schedule 2</label>
                        <Calendar
                          value={
                            row.flight_schedule2
                              ? new Date(row.flight_schedule2)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "flight_schedule2",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label>Flight Route 3</label>
                        <InputText
                          value={row.route3 || ""}
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "route3",
                              e.target.value,
                            )
                          }
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label>Flight Schedule 3</label>
                        <Calendar
                          value={
                            row.flight_schedule3
                              ? new Date(row.flight_schedule3)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "flight_schedule3",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label>Pickup Date</label>
                        <Calendar
                          value={
                            row.pickup_date ? new Date(row.pickup_date) : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "pickup_date",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label>Clearance Date</label>
                        <Calendar
                          value={
                            row.clearance_date
                              ? new Date(row.clearance_date)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "clearance_date",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>
                      <div className="field col-12 md:col-3">
                        <label>Transit Days</label>
                        <InputText
                          value={row.transit_days || ""}
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "transit_days",
                              e.target.value,
                            )
                          }
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label>Validity Date</label>
                        <Calendar
                          value={
                            row.freight_validity
                              ? new Date(row.freight_validity)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "freight_validity",
                              e.value,
                            )
                          }
                          showIcon
                          dateFormat="dd/mm/yy"
                          className="w-full"
                        />
                      </div>

                      <div className="field col-12">
                        <label>Remarks / Conditions</label>
                        <InputTextarea
                          value={row.remarks || ""}
                          onChange={(e) =>
                            handleInputChange(
                              shipment,
                              shipmentIndex,
                              idx,
                              "remarks",
                              e.target.value,
                            )
                          }
                          rows={2}
                          className="w-full"
                        />
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex justify-content-end gap-2 mt-3">
                      <Button
                        icon="pi pi-send"
                        label="Submit Flight Schedule"
                        className="p-button-success mt-3 mr-4"
                        disabled={
                          rowData.status === "accepted" ||
                          !airlineData[shipmentIndex] ||
                          airlineData[shipmentIndex].length === 0
                        }
                        onClick={() =>
                          handlePackageSubmit(shipmentIndex, rowData)
                        }
                      />
                      <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-danger"
                        onClick={() => handleDeleteRow(shipmentIndex, idx)}
                        label="Delete Entry"
                      />
                    </div>
                  </div>
                ))}

                <DataTable
                  value={shipment.package_summary?.packages || []}
                  responsiveLayout="scroll"
                  className="p-datatable-sm"
                >
                  <Column field="type" header="Package Type" />
                  <Column field="number" header="No. of Pkgs" />
                  <Column field="length" header="Length (cm)" />
                  <Column field="breadth" header="Breadth (cm)" />
                  <Column field="height" header="Height (cm)" />
                  <Column field="gross_weight" header="Gross Wt (kg)" />

                  <Column
                    header="Action"
                    body={(pkg, options) => {
                      const rowIndex = options.rowIndex;
                      return (
                        <Button
                          style={{ display: "none" }}
                          label="Place Quote"
                          icon="pi pi-check"
                          className="p-button-sm p-button-success"
                          onClick={() =>
                            handlePackageSubmit(
                              shipmentIndex,
                              rowIndex,
                              rowData,
                            )
                          }
                        />
                      );
                    }}
                  />
                </DataTable>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const header = <h5 className="mb-2">RFQ List</h5>;

  const getAuctionStateMeta = (rowData) => {
    const now = new Date();
    const startTime = rowData?.open_date_time
      ? new Date(rowData.open_date_time)
      : null;
    const endTime = rowData?.close_date_time
      ? new Date(rowData.close_date_time)
      : null;
    const normalizeStatusValue = (value) =>
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, "_");

    const normalizedStatus = normalizeStatusValue(rowData?.status);
    const normalizedFormType = normalizeStatusValue(rowData?.form_type);
    const reAuctionValues = [
      "reauction_scheduled",
      "reauction_submitted",
      "re_auction_scheduled",
      "re_auction_submitted",
      "reaction_scheduled",
      "reaction_submitted",
    ];

    if (normalizedStatus === "draft" || normalizedFormType === "draft") {
      return { label: "Draft", severity: "secondary" };
    }

    const reAuctionMatch = [normalizedStatus, normalizedFormType].some(
      (value) => {
        if (!value) return false;
        if (reAuctionValues.includes(value)) return true;
        return (
          value.includes("reauction") ||
          value.includes("re_auction") ||
          value.includes("reaction")
        );
      },
    );

    if (startTime && now < startTime) {
      if (reAuctionMatch) {
        return { label: "Re-Auction Scheduled", severity: "warning" };
      }

      if (rowData?.auction_number) {
        return { label: "Scheduled", severity: "warning" };
      }
    }

    if (endTime && now > endTime) {
      return { label: "Ended", severity: "danger" };
    }

    if (rowData?.auction_number || reAuctionMatch || startTime || endTime) {
      return { label: "Live", severity: "success" };
    }

    if (["accepted", "hod_approved", "approved"].includes(normalizedStatus)) {
      return { label: "Approved", severity: "success" };
    }

    if (
      ["evaluated", "negotiation", "requested_hod_approval"].includes(
        normalizedStatus,
      )
    ) {
      return { label: "In Review", severity: "info" };
    }

    if (["rejected"].includes(normalizedStatus)) {
      return { label: "Rejected", severity: "danger" };
    }

    const fallback = rowData?.status
      ? getVendorStatusFromBuyerStatus(rowData.status)
      : getVendorStatusFromBuyerStatus(rowData?.form_type);

    if (fallback && fallback.toUpperCase() !== "PENDING") {
      return { label: fallback.toUpperCase(), severity: "info" };
    }

    return { label: "Open", severity: "secondary" };
  };

  const renderStatusBadge = (rowData) => {
    const { label, severity } = getAuctionStateMeta(rowData);
    return (
      <Tag
        value={label}
        severity={severity}
        className="px-3 py-2 text-xs font-semibold border-round-md"
        style={{ minWidth: "7.5rem", textAlign: "center" }}
      />
    );
  };

  const getRowStateStyle = (rowData) => {
    const { severity } = getAuctionStateMeta(rowData);

    const palette = {
      warning: {
        backgroundColor: "#fff7e6",
        borderLeft: "4px solid #f59e0b",
      },
      danger: {
        backgroundColor: "#fef2f2",
        borderLeft: "4px solid #ef4444",
      },
      success: {
        backgroundColor: "#eafff3",
        borderLeft: "5px solid #16a34a",
        boxShadow: "inset 0 0 0 1px rgba(22, 163, 74, 0.18)",
      },
      info: {
        backgroundColor: "#eff6ff",
        borderLeft: "4px solid #3b82f6",
      },
      secondary: {
        backgroundColor: "#f8fafc",
        borderLeft: "4px solid #94a3b8",
      },
    };

    return palette[severity] || { backgroundColor: "#ffffff" };
  };

  const actionBodyTemplate = (rowData) => (
    <div className="flex gap-2">
      <Button
        icon="pi pi-eye"
        className="p-button-sm p-button-info"
        onClick={() =>
          navigate(
            rowData.auction_number
              ? `/rfq/view/${rowData.rfq_number}?source=auction`
              : `/rfq/view/${rowData.rfq_number}`,
          )
        }
      />
      <Button
        icon="pi pi-trash"
        className="p-button-sm p-button-danger"
        onClick={() => handleDelete(rowData.rfq_number)}
      />
      {rowData.status === "evaluated" && (
        <Button
          label="Convert to Auction"
          icon="pi pi-forward"
          className="p-button-sm p-button-warning"
          onClick={() =>
            navigate(`/rfq/view/${rowData.rfq_number}?source=auction`)
          }
        />
      )}

      {rowData.form_type !== "draft" && (
        <Button
          label="View Details"
          icon="pi pi-list"
          className="p-button-sm p-button-secondary"
          onClick={() => navigate(`/quote-summary/${rowData.rfq_number}`)}
        />
      )}
    </div>
  );

  const handleDelete = async (rfq_number) => {
    if (!window.confirm("Are you sure you want to delete this RFQ?")) return;

    const response = await postData(`rfqs/${rfq_number}/delete`, {});
    if (response?.isSuccess) {
      dispatch(toastSuccess({ detail: "RFQ deleted successfully!" }));
      fetchRfqs();
    } else {
      dispatch(
        toastError({ detail: response?.msg || "Failed to delete RFQ." }),
      );
    }
  };

  const submitQuote = async (rfqId) => {
    //console.log("quotes on submit", quotes);
    const rfq = rfqs.find((r) => r.rfq_number === rfqId);
    const vendorId = user.id;
    const itemQuotes = (rfq.rfq_items || []).map((item, index) => {
      const itemKey = `${rfq.rfq_number}_${index + 1}`;
      //console.log("item key value", itemKey);
      const quoted_price = parseFloat(quotes[itemKey]);
      //console.log("quoted price value", quoted_price);

      return {
        item_id: index + 1,
        quoted_price: isNaN(quoted_price) ? 0 : quoted_price,
        item_name: item.item_name,
        status: "submitted",
      };
    });
    const payload = {
      rfq_id: rfqId,
      vendor_id: parseInt(vendorId),
      quotes: itemQuotes,
    };

    //console.log("payload value::", payload);

    try {
      const token = localStorage.getItem("USERTOKEN");

      const response = await fetch("/apis/quotes", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      console.log("Submit Quote response:", result);

      // ❌ API returned an error
      if (!response.ok || result?.isSuccess === false) {
        dispatch(
          toastError({
            detail: result?.message || result?.msg || "Failed to submit quote.",
          }),
        );

        return;
      }

      // ✅ API success
      dispatch(
        toastSuccess({
          detail: "Quote Submitted Successfully.",
        }),
      );
    } catch (error) {
      console.error("Error submitting quote:", error);

      dispatch(
        toastError({
          detail: "Failed to submit quote. Please try again.",
        }),
      );
    }
  };

  const handleRoadTransportQuoteSubmit = async (rfqId) => {
    const rfq = rfqs.find((r) => r.rfq_number === rfqId);
    const vendorId = user.id;

    if (!rfq || !rfq.road_transport_summary?.entries) {
      console.warn("Invalid RFQ or road transport data");
      return;
    }

    const quotesPayload = rfq.road_transport_summary.entries.map(
      (entry, index) => {
        const rowKey = `${rfq.rfq_number}_${index}`;
        const quoted_price = parseFloat(roadTransportQuotes[rowKey]);
        return {
          row_id: index + 1,
          source: entry.source,
          sourceZip: entry.sourceZip,
          destination: entry.destination,
          destinationZip: entry.destinationZip,
          loadingBy: entry.loadingBy,
          unloadingBy: entry.unloadingBy,
          material: entry.material,
          requirement: entry.requirement,
          requirementUnit: entry.requirementUnit,
          materialWeight: entry.materialWeight,
          materialUnit: entry.materialUnit,
          vehicleType: entry.vehicleType,
          dateTime: entry.dateTime,
          distance: entry.distance,
          distanceUnit: entry.distanceUnit,
          quoted_price: isNaN(quoted_price) ? 0 : quoted_price,
          vendor_id: vendorId,
          status: "submitted",
        };
      },
    );

    const payload = {
      rfq_id: rfq.rfq_number,
      vendor_id: vendorId,
      road_transport_quotes: quotesPayload,
    };

    //console.log("🚛 Road Transport Quote Payload", payload);

    try {
      const token = localStorage.getItem("USERTOKEN");
      const response = await fetch("/apis/quotes", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      //console.log("Submit Quote  response", result);
      dispatch(toastSuccess({ detail: "Quote Submitted Successfully.." }));
    } catch (error) {
      //console.error("Error submitting quote:", error);
    }
  };

  return (
    <div className="p-4">
      <h3>RFQ - Auction Management</h3>

      <div className="flex flex-wrap gap-2 align-items-center mb-3">
        <span
          className="inline-flex align-items-center gap-2 px-2 py-1 border-round-md"
          style={{
            background: "#fff7e6",
            border: "1px solid #facc15",
            color: "#9a6700",
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "#f59e0b",
              display: "inline-block",
            }}
          />
          Scheduled
        </span>
        <span
          className="inline-flex align-items-center gap-2 px-2 py-1 border-round-md"
          style={{
            background: "#fff1f2",
            border: "1px solid #f9a8d4",
            color: "#9d174d",
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "#ec4899",
              display: "inline-block",
            }}
          />
          Re-Auction Scheduled
        </span>
        <span
          className="inline-flex align-items-center gap-2 px-2 py-1 border-round-md"
          style={{
            background: "#dcfce7",
            border: "2px solid #16a34a",
            color: "#166534",
            fontWeight: 700,
            boxShadow: "0 0 0 1px rgba(22, 163, 74, 0.15)",
          }}
        >
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "#16a34a",
              display: "inline-block",
              boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.2)",
            }}
          />
          Live
        </span>
        <span
          className="inline-flex align-items-center gap-2 px-2 py-1 border-round-md"
          style={{
            background: "#fef2f2",
            border: "1px solid #f87171",
            color: "#991b1b",
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              background: "#ef4444",
              display: "inline-block",
            }}
          />
          Ended
        </span>
      </div>

      <div className="flex justify-content-end mb-3">
        <span className="p-input-icon-left w-full md:w-30rem">
          <i className="pi pi-search" />
          <InputText
            placeholder="Global Search"
            className="w-full"
            onInput={(e) => setGlobalFilter(e.target.value)}
          />
        </span>
      </div>
      {(role === "user" || role === "hod" || role === "accounts") && (
        <DataTable
          value={rfqs}
          paginator
          rows={10}
          responsiveLayout="scroll"
          sortMode="multiple"
          removableSort
          globalFilter={globalFilter}
          filters={filters}
          filterDisplay="menu"
          onFilter={(e) => setFilters(e.filters)}
          globalFilterFields={[
            "title",
            "form_type",
            "transport_mode",
            "currency",
            "rfq_number",
            "auction_number",
            "buyer.preshipmentnumber",
            "buyer.postshipmentnumber",
          ]}
          className="p-datatable-sm"
          rowStyle={getRowStateStyle}
        >
          <Column
            field="buyer.preshipmentnumber"
            //filter
            filterField="rfq_number"
            filterPlaceholder="Search..."
            body={(rowData) => rowData.auction_number || rowData.rfq_number}
            header="RFQ / Auction #"
            sortable
          />
          <Column
            field="buyer.postshipmentnumber"
            //filter
            filterField="postshipmentnumber"
            filterPlaceholder="Search..."
            header="Shipment Number"
            body={(rowData) =>
              rowData?.buyer?.postshipmentnumber ||
              rowData?.buyer?.preshipmentnumber ||
              "-"
            }
            sortable
          />
          <Column
            field="title"
            header="Title"
            sortable
            //filter
            filterPlaceholder="Search..."
            body={(rowData) => rowData.title?.toUpperCase()}
          />
          <Column
            field="form_type"
            body={renderStatusBadge}
            header="Status"
            sortable
            filterPlaceholder="Search..."
          />
          <Column
            header="Vendors Responded"
            sortable
            //filter
            filterPlaceholder="Search..."
            body={(rowData) =>
              rowData.quote_count ? `${rowData.quote_count}` : "No Quotes"
            }
          />
          <Column
            field="createdAt"
            header="Created Date"
            sortable
            //filter
            body={(rowData) => formatDate(rowData.createdAt, false, true)}
          />
          <Column
            field="open_date_time"
            header="Open Date"
            sortable
            //filter
            body={(rowData) => formatDate(rowData.open_date_time, false, true)}
          />
          <Column
            field="close_date_time"
            header="End Date"
            sortable
            //filter
            body={(rowData) => formatDate(rowData.close_date_time, false, true)}
          />
          <Column
            header="Actions"
            body={actionBodyTemplate}
            style={{ minWidth: "8rem" }}
          />
        </DataTable>
      )}
      {role === "vendor" && (
        <DataTable
          value={filteredRfqs}
          expandedRows={expandedRows}
          // onRowToggle={(e) => setExpandedRows(e.data)}
          // onRowExpand={(e) => fetchQuotesById(e.data.rfq_number)}
          onRowExpand={handleRowExpand}
          onRowCollapse={handleRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey="row_id"
          responsiveLayout="scroll"
          className="p-datatable-gridlines"
          paginator
          rows={5}
          header={header}
          rowStyle={getRowStateStyle}
        >
          <Column expander style={{ width: "3rem" }} />
          <Column
            body={(rowData) => rowData.auction_number || rowData.rfq_number}
            header="RFQ / Auction #"
          />
          <Column
            body={(rowData) =>
              rowData.buyer.preshipmentnumber ||
              rowData.buyer.postshipmentnumber
            }
            header="Shipment Number"
          />
          <Column
            body={(rowData) =>
              rowData.title ? rowData.title.toUpperCase() : ""
            }
            header="Title"
          />
          <Column
            body={(rowData) =>
              rowData.rfq_type ? rowData.rfq_type.toUpperCase() : ""
            }
            header="Type"
          />
          <Column field="buyer.email" header="Buyer Name" />
          <Column
            body={(rowData) => formatDate(rowData.close_date_time)}
            header="Submission Deadline"
          />
          {/* <Column field="rfq_items.length" header="Items Count" /> */}
          <Column body={renderStatusBadge} header="Status" />
          <Column
            header="Actions"
            body={(rowData) => (
              <Button
                icon="pi pi-eye"
                className="p-button-sm p-button-info"
                onClick={() =>
                  navigate(
                    rowData.auction_number
                      ? `/rfq/view/${rowData.rfq_number}?source=auction`
                      : `/rfq/view/${rowData.rfq_number}`,
                  )
                }
              />
            )}
          />
        </DataTable>
      )}

      <Dialog
        header="Vendor Cost Breakdown Upload"
        visible={showVendorUpload}
        style={{ width: "50vw" }}
        modal
        onHide={() => setShowVendorUpload(false)}
      >
        {selectedRow && (
          <VendorCostUpload
            row={selectedRow}
            refreshData={() => {
              fetchQuotesById(selectedRow.rfqNumberForQuoteSummary);
              setShowVendorUpload(false);
            }}
          />
        )}
      </Dialog>
    </div>
  );
};

export default RfqManagement;
